import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header/index';
import Sidebar from '../components/Sidebar/index';
import InstallBanner from '../components/InstallBanner';

export default function DefaultLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-ground font-sans text-sm leading-[1.45] text-ink">
      <InstallBanner />
      <div className="flex min-h-0 flex-1 overflow-hidden">
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      {/* `relative`: absolutely positioned descendants (sr-only labels, hidden inputs) anchor to this
          scroller, not the page; otherwise they stretch the document and the page scrolls past the shell. */}
      <main className="relative min-w-0 flex-1 overflow-y-auto overflow-x-hidden px-4 pb-14 sm:px-9">
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <Outlet />
      </main>
      </div>
    </div>
  );
}
